export const environment = {
  production: false,
  apiBaseUrl: '',
  //apiBaseUrl: 'https://localhost:7224',
  stripePublishableKey: "pk_test_51SYVtW1ygzM1C1WB5SkHJ9aJyx1ROTrtm5GTDhnpHOGdpsCRRgSsJgrh3NVicW6BeirdZYimTBHGRtt1dIBmIFIl003EBfygTW"
};
